/**
 * 开户有关信息
 */
import apis from 'src/const/apis';
import request from 'src/utils/request';
import * as types from 'src/store/types';

const user = {
  namespaced: true, // 带 user 命名空间
  state: {
    refundInfo: {}, // 退款状态
  },
  getters: {
    refundInfo(state) {
      return state.refundInfo;
    },
  },
  mutations: {
    [types.SET_USER_REFUND_INFO](state, info) {
      state.refundInfo = info;
    },
  },
  actions: {
    setPromotion({ commit }, data) {
      return request.post(apis.user.promotion, data);
    },
    // 校验邀请链接
    checkInvite({ commit }, data) {
      return request.get(apis.user.selfInvite, data);
    },
    // 自助账户提交调查问卷
    postSurvey({ commit }, data) {
      return request.post(apis.user.postSurvey, data);
    },

    // 退款状态
    getRefundStatus({ commit }, data) {
      // return request.get(apis.close.refund_status, data);
      request.get(apis.close.refund_status, data).then(({ data: info }) => {
        commit(types.SET_USER_REFUND_INFO, info);
      });
    },

    // 退款金额
    getRefundBalance({ commit }, data) {
      return request.get(apis.close.balance, data);
    },
    // 发起退款&关户
    submitRefundAndCloseAccount({ commit }, data) {
      return request.post(apis.close.submit, data);
    },
  },
};

export default user;
